import React from 'react';

import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { connectProps } from 'store';
import { langProp, updateCurrentPage } from 'model/component-props';

import content from './content';
import './searchbar.css';

class Searchbar extends React.Component {
  handleChange = (ev) => {
    this.props.updateSearchTerm(ev.target.value);
    this.props.updateCurrentPage(0);
  }

  chooseItemViewName(item, langProp) {
    switch (item)
    {
      case 'Description': 
        return content[langProp].Description;
      case 'No':
        return content[langProp].ID;
      case 'Sample_Description':
        return content[langProp].SampleDescription;
      case 'Inventory':
        return content[langProp].Inventory;
      case 'Special_Weight':
        return content[langProp].SpecialWeight;
      case 'Composition':
        return content[langProp].Composition;
      case 'Width':
        return content[langProp].Width;
      case 'Unit_Price':
        return content[langProp].UnitPrice;
      case 'Name':
        return content[langProp].Name;
      case 'No':
        return content[langProp].No;
      case 'Address':
        return content[langProp].Address;
      case 'Phone_No':
        return content[langProp].Phone_No;
      case 'Balance_LCY':
        return content[langProp].Balance_LCY;
      case 'Post_Code':
        return content[langProp].Post_Code;
      case 'City':
        return content[langProp].City;
      default:
        return '';
    }
  }

  render(){
  const {
    updateSearchKey,
    searchKey,
    searchTerm,
    searchKeysList,
    langProp 
  } = this.props;
    return (
      <div className={'searchbar-box'}>
        <Select
          value={searchKey}
          onChange={ev => updateSearchKey(ev.target.value)}
          className={'select'}
        >
          {searchKeysList.map(item =>
            <MenuItem key={item} value={item}>{this.chooseItemViewName(item, langProp)}</MenuItem>)
          }
        </Select>
        <TextField
          id={'search-textfield'}
          label={content[langProp].label}
          className={'textfield'}
          value={searchTerm}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default connectProps(langProp, updateCurrentPage)(Searchbar);



// WEBPACK FOOTER //
// ./src/components/searchbar/Searchbar.js